import { render, staticRenderFns } from "./IlluYes.vue?vue&type=template&id=79dc04bc&"
import script from "./IlluYes.vue?vue&type=script&lang=js&"
export * from "./IlluYes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports